import { IContactEmailData, IContactAddressData } from "./ContactAddressData";

export const defaultAddressData: IContactAddressData = {
  addressLine1: "",
  addressLine2: "",
  city: "",
  province: "",
  postalCode: "",
  country: "Canada",
}

export const defaultData: IContactEmailData = {
  employeeEmail: "",
  employeeAddress: defaultAddressData,
  provinceOptions: []
};

export enum ProgressBarSteps {
  VerifyEmail = "Verify Email",
  UpdateAddress = "Update Address",
  Confirmation = "Confirmation",
}
